module.exports = {
	"list": "findify-components--tabs__list",
	"body": "findify-components--tabs__body",
	"dropdown": "findify-components--tabs__dropdown",
	"tab": "findify-components--tabs__tab",
	"active": "findify-components--tabs__active",
	"disabled": "findify-components--tabs__disabled"
};